import "babel-polyfill";
import "formdata-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { ToastContainer, toast } from "react-toastify";
import MediaQuery from "react-responsive";

import { Provider } from "react-redux";
import { persistStore } from 'redux-persist'
import { PersistGate } from "redux-persist/lib/integration/react";

import { routes } from "./routes";
import {store} from './store';

const persistor = persistStore(store);

const provider = (
  <Provider store={store} key="provider">
    <div>
      <MediaQuery minWidth={992}>
        <ToastContainer
          autoClose={4000}
          className="finpay-toast"
          hideProgressBar={true}
          position={toast.POSITION.TOP_RIGHT}
        />
      </MediaQuery>
      <MediaQuery minWidth={320} maxWidth={991}>
        <ToastContainer
          className="finpay-toast"
          autoClose={4000}
          hideProgressBar={true}
          position={toast.POSITION.BOTTOM_CENTER}
        />
      </MediaQuery>
      <PersistGate loading={null} persistor={persistor}>
        {routes()}
      </PersistGate>
    </div>
  </Provider>
);

const rootElement = document.getElementById("root");

ReactDOM.render(provider, rootElement);



// WEBPACK FOOTER //
// ./src/index.js